<template>
  <div class="calm__form-row" :class="{ 'has-error': !!error }">
    <label v-if="label || required" class="calm__form-row__label" :for="forId">
      {{ label }}<span v-if="required" class="req">*</span>
    </label>

    <!-- the field itself: an <input class="ed">, <el-input>, <el-select>, etc. -->
    <slot></slot>

    <!-- hint shown only when there's no error competing for the space -->
    <div v-if="hint && !error" class="calm__form-row__hint">{{ hint }}</div>

    <!-- vee-validate error message -->
    <div v-if="error" class="calm__form-row__error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "calm-form-row",
  props: {
    label: { type: String, default: "" },
    required: { type: Boolean, default: false },
    hint: { type: String, default: "" },
    error: { type: String, default: "" }, // pass errors[0] from ValidationProvider
    forId: { type: String, default: undefined }, // optional <label for>
  },
};
</script>
